"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPartInvestissementPatrimoineGlobalCorporationTrads = void 0;
exports.ESubPartInvestissementPatrimoineGlobalCorporationTrads = {
    percent_between_11_20: "Entre 11% et 20%",
    percent_between_1_5: "Entre 1% et 5%",
    percent_between_6_10: "Entre 6% et 10%",
    percent_greater_20: "Supérieur à 20%",
};
